import React, { useState, useEffect } from "react";
import LayoutExpert from "../../NewComponent/LayoutExpert/Layout";
import Layout from "../../NewComponent/Layout/Layout";
import { useSelector, useDispatch } from "react-redux";
import { Actions } from "../../Action";
import { bindActionCreators } from "redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Home_PAGE_URL } from "../../Router/routerUrl";
import {
	notificationAction,
	getInlineImage,
	markUnmarkFavourite,
	getAnswerRatingsInNotificationAction,
	rateRecommandedAnswer,
	URLDerectionData,
	getExpertsProfilePics,
	askClarificationExpert,
	getQuestionDraftData,
	URLOpenDerectionData,
	FetchForceReroute,
	editQuestionText, recommendQuestionData, getAttachmentShowURL, rateAnswer
} from "../../API/api";
import { toast } from "react-toastify";
import { handleError, momentit, replaceContentEditableText } from "../../utils";
import { Spin } from "antd";
import { ReactComponent as HeartIcon } from "../../Icons/heart.svg";
import { ReactComponent as HeartSelectedIcon } from "../../Icons/heartSelect.svg";
import AttachmentBox from "../../NewComponent/AttachmentBox/AttachmentBox";
import { Popover, Dropdown, Button, Tag } from "antd";
import Button2 from "../../NewComponent/Button2/Button2";
import { ReactComponent as DownloadIcon } from "../../Icons/download.svg";
import Tags from "./Tags";
import NameInfo from "./NameInfo";
import { CURRENT_ROLE } from "../../API/url";
import Rating from "../../NewComponent/Rating/Rating";
import { message } from "antd";
import { handlePauseAllVideo, removeStylesFromHtml } from "../../utils";
import { ReactComponent as ArrowUpIcon } from "../../Icons/arrowUp.svg";
import { ReactComponent as ArrowDownIcon } from "../../Icons/arrowDown.svg";
import ImgCarousal from "../../NewComponent/Carousal/carousal";
import { ReactComponent as RFUIcon } from "../../Icons/rfuIcon.svg";
import Button3 from "../../NewComponent/Button/Button";
import { instance } from "../../API/api";
import { GET_FILES } from "../../API/url";
import { ReactComponent as URLIcon } from "../../Icons/crawl.svg";
import KeyTagDataBox from "../KeyTermPage/KeyTagDataBox";
import { styled, } from '@mui/material/styles';
import FontDownloadIcon from '@mui/icons-material/FontDownload';
import { ReactComponent as FireIcon } from "./../../Icons/fire.svg";




export default function RecommendPageNew() {
	const dispatch = useDispatch();
	const {
		notificationsDataRecommend,
		notificationDataLoading,
		advanceFilterModalToggle,
		getSelectedAnswer,
		getSelectedQuestion,
		attachmentData,
		isBackClickedOnRecommend,
		recommendData,
		preservePreviousRecommendData,
		getkeyTagPayload,
		getExpertRequestUuid,
		questionDataForEditor,
		updateSubmissionTypeForEditor,
		updateAnswerTextForEditor,
		updatePageNumberExpertOpenTab,
		getDomainOfQuestion,
		getSelectedQuestionDataExpert,
		getForceRerouteUsersStatus,
		updateAttachmentForEditor,
		getSeekerAttachmentsForReccommend,
		getSeekerAttachment,
		getRecommendationsData,
		getSeekerAttachmentsForAnswered,
		updateSearchData2,
		updatePageNoAnswered,
		AnsweredPageBool,
		updateRatingBoolean
	} = bindActionCreators(Actions, dispatch);
	const navigate = useNavigate();
	const currentRoute = useLocation();
	  const editorState = useSelector((state) => state.editor);
	const keyTagState = useSelector(state => state.keyTag);
	const [isShowReply, setIsShowReply] = useState(false);
	const recommedState = useSelector((state) => state.recommend);
	const data = useSelector((state) => state.recommend.data);
	const origData = useSelector((state) => state.recommend.data);
	const [ratings, setRatings] = useState(null);
	const [clarify, setClarify] = useState(false);
	const [val, setValue] = useState("");
	const [additional, setAdditional] = useState("");
	const questiondata = useSelector((state) => state.recommend);
	const questionText = useSelector((state) => state.recommend.data.question);
	const searchState = useSelector((state) => state.search);
	const userState = useSelector((state) => state.user);
	const [allInlineImages, setAllInlineImages] = useState(null);
	const [ratingIds, setRatingIds] = useState([]);
	const [docIds, setDocIds] = useState([]);
	const [recommendations, setRecommendation] = useState([]);
	const [clarificationTextExpert, setClarificationTextExpert] = useState("");
	const [isShowAnswerButton, setIsShowAnswerButton] = useState(false);
	const [permission, setPermission] = useState(userState.roles.find(data => data.roleName === CURRENT_ROLE).permissions.find(item => item.id === 9));
	const [isAccept, setAccept] = useState(null);
	const [isPlay, setPlay] = useState(false);
	const ratingState = useSelector((state) => state.domain);
	const [edit, setEdit] = useState(false)
	const [clarified, setClarified] = useState(false)
	const isButtonDisabled = data.clarificationStatus
		? ((data.question === val || data.questionText === val) && (data.additionalContext === additional)) || val === '' || additional === ''
		: val === '';
	const [showButtons, setShowButtons] = React.useState(false);



	const trimString = (str) => {
		if (str.length > 350) {
			return str.slice(0, 350) + "...";
		}
		return str;
	};

	const contentStyle = {
		border: "1px solid #E0E2E6",
		borderRadius: "16px",
		boxShadow: "0px 4px 16px 0px #1018280F",
		width: '100%'
	};

	const containerStyles = {
		border: "1px solid #E0E2E6",
		borderRadius: "16px",
		background: "#FFFFFF",
		boxShadow: "0px 4px 16px 0px #1018280F",
		padding: "24px 36px 24px 36px",
		minHeight: "100px",
		marginBottom: '24px'
	}
	const textStyles = {
		fontSize: "24px",
		color: "#2A364A",
		lineHeight: "32px",
		fontWeight: "400",
		wordBreak: 'break-word',overflowWrap: 'break-word',
		// width:'100%',
		gap:'10px'
	};

	const additionalContextStyles = {
		border: '1px solid rgb(246, 247, 248)',
		marginBlock: '10px',
		borderRadius: '6px',
		background: 'rgb(246, 247, 248)',
		padding: '12px',
		minHeight: '48px',
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap'
	}

	const hrStyles = {
		border: 'none',
		borderBottom: '1.5px solid',
		borderImage: 'linear-gradient(90deg, #00D1FF 0%, #BD00FF 15.98%, #0075FF 29.15%, #00E0FF 43.18%)',
		borderImageSlice: 1,
		marginTop: '15px',
		marginBottom: '12px'
	};

	const ansStyles = {
		marginTop: "10px",
		fontSize: "15px",
		color: "#5C667B",
		lineHeight: "24px",
		fontWeight: "300",
		wordBreak: 'break-word',overflowWrap: 'break-word',
	};
	const showMoreStyles = {
		fontSize: "15px",
		color: "#5C667B",
		lineHeight: "20px",
		fontWeight: "500",
		background:
			"linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)",
		backgroundClip: "text",
		"-webkit-text-fill-color": "transparent",
		"-moz-text-fill-color": "transparent",
		"-ms-text-fill-color": "transparent",
		"-o-text-fill-color": "transparent",
		cursor: "pointer",
		marginTop: "5px",
	};

	const showThreadStyles = {
		fontSize: '15px',
		color: 'rgb(92, 102, 123)',
		lineHeight: '20px',
		fontWeight: 400,
		background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
		WebkitTextFillColor: 'transparent',
		cursor: 'pointer',
		marginTop: '5px',
		backgroundClip: 'text'
	};

	{/* Styling for Expert Action Buttons start */ }
	const RerouteButton = styled(Button)({
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		height: '40px',
		minWidth: '88px',
		backgroundImage: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)', // Gradient background
		textTransform: 'capitalize',
		':hover': {
			backgroundImage: 'linear-gradient(90.39deg, #0075FF 0.34%, #00D1FF 99.7%)', // Reversed gradient on hover
			color: '#FFFFFF',
			borderColor: '#FFFFFF',
		},
	});


	const DeclineButton = styled(Button)({
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		height: '40px',
		minWidth: '140px',
		backgroundImage: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
		textTransform: 'capitalize',
		':hover': {
			backgroundImage: 'linear-gradient(90.39deg, #0075FF 0.34%, #00D1FF 99.7%)',
			color: '#FFFFFF',
			borderColor: '#FFFFFF',
		},
	});

	const rerouteButtonStyles = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		// color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		height: '40px',
		minWidth: '140px',
	};

	const declineButtonStyles = {
		padding: '8px 12px 8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		color: '#FFFFFF',
		border: '1px solid #fff',
		height: '40px',
		minWidth: '140px',
		background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
	};


	const verifyNowButtonStyles = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		height: '40px',
		minWidth: '140px',
		backgroundImage: 'linear-gradient(to right, #ffa366 10%, #fd7400e8 50%, #d65e00 90%)', // Subtle gradient on the left
		textTransform: 'capitalize',
		':hover': {
			backgroundImage: 'linear-gradient(to right, #d65e00 10%, #fd7400e8 50%, #ffa366 90%)', // Reversed gradient on hover
			color: '#FFFFFF',
			borderColor: '#FFFFFF',
		},
	};

	const answerNowButtonStyles = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: '0px 1px 2px 0px #1018280D',
		color: '#FFFFFF',
		border: '1px solid #FFFFFF',
		height: '40px',
		minWidth: '140px',
		backgroundImage: 'linear-gradient(to right, #d1e17d 20%, #bedb39 50%, #a1b73d 90%)', // Lighter on the left and darker on the right
		textTransform: 'capitalize',
		':hover': {
			backgroundImage: 'linear-gradient(to right, #a1b73d 20%, #bedb39 50%, #d1e17d 90%)', // Reversed gradient on hover
			color: '#FFFFFF',
			borderColor: '#FFFFFF',
		},
	};

	const AnswerNowButton = styled(Button)({
		backgroundImage: 'linear-gradient(to right, #bedb39, #fff)',
		borderColor: '#bedb39',
		border: '1px solid #bedb39',
		color: '#fff',
		borderRadius: '3px',
		margin: '0px 3px',
		fontFamily: 'Poppins, Lato, sans-serif',
		fontSize: '14px',
		minWidth: '150px',
		textTransform: 'capitalize',
		fontWeight: 300,
		':hover': {
			backgroundImage: 'linear-gradient(to right, #fff, #bedb39)',
			borderColor: '#bedb39',
			border: '1px solid #bedb39',
			color: '#bedb39',
		},
	});

	const VerifyNowButton = styled(Button)({
		backgroundImage: 'linear-gradient(to right, #fd7400e8, #fff)',
		borderColor: '#fd7400e8',
		border: '1px solid #fd7400e8',
		color: '#fff',
		borderRadius: '3px',
		margin: '0px 3px',
		fontFamily: 'Poppins, Lato, sans-serif',
		fontSize: '14px',
		minWidth: '150px',
		textTransform: 'capitalize',
		fontWeight: 300,
		':hover': {
			backgroundImage: 'linear-gradient(to right, #fff, #fd7400e8)',
			borderColor: '#fd7400e8',
			border: '1px solid #fd7400e8',
			color: '#fd7400e8',
		},
	});

	const UpdateAnswerButton = styled(Button)({
		backgroundImage: 'linear-gradient(to right, #fd7400e8, #fff)',
		borderColor: '#fd7400e8',
		border: '1px solid #fd7400e8',
		color: '#fff',
		borderRadius: '3px',
		margin: '0px 3px',
		fontFamily: 'Poppins, Lato, sans-serif',
		fontSize: '14px',
		minWidth: '150px',
		textTransform: 'capitalize',
		fontWeight: 300,
		':hover': {
			backgroundImage: 'linear-gradient(to right, #fff, #fd7400e8)',
			borderColor: '#fd7400e8',
			border: '1px solid #fd7400e8',
			color: '#fd7400e8',
		},
	});

	{/* Styling for Expert Action Buttons end */ }

	const onClickModalDecline = () => {
		advanceFilterModalToggle({ bool: true, value: "expertDecline" });
		getExpertRequestUuid(data.expertRequestUuid);
	}

	const successfulQuestionUpdated = (message) => {
		return (
			<>
				<span style={{ fontSize: "12px" }}>{message}</span>
			</>
		);
	};

	const successfulClarificationQuestion = () => {
		return (
			<>
				<p style={{ fontSize: "13px", fontWeight: "bold" }}>Great!</p>
				<span style={{ fontSize: "11px" }}>
					Your request for clarification has been forwarded to the seeker
				</span>
			</>
		);
	};

	const questionNotInYourQueue = (message) => {
		return (
			<span style={{ fontSize: '12px' }}>{message}</span>
		)
	}

	const onClickMarkFavorite = () => {
		markUnmarkFavourite(recommedState.data.questionUuid)
			.then((res) => {
				recommedState.data.favourite = !recommedState.data.favourite;
				notificationsDataRecommend(data);
			})
			.catch((err) => handleError(err));
	};

	const callApi = () => {
		if (!recommedState.isBack) {
			let preservedData = recommedState.prevData;
			preservedData.push(recommedState.recommendPayload);
			preservePreviousRecommendData(preservedData);
		}
		if (
			recommedState.recommendPayload.data &&
			recommedState.recommendPayload.data.queUuid !== undefined
		) {
			setRecommendation([]);
			notificationDataLoading(true);
			let userUuid = [];
			const payload = {
				notificationId: [recommedState.recommendPayload.data.msgUuid],
				questionUuid: [recommedState.recommendPayload.data.queUuid],
			};
			notificationAction(payload).then((res) => {
				if (res === undefined) return;
				if (res !== undefined && res.data.success) {
					if (res.data.data.seekerAttachments && res.data.data.seekerAttachments !== null) {
						getSeekerAttachmentsForReccommend(res.data.data.seekerAttachments)
					}
					let answerUuids = res.data.data.answers.map((k, i) => {
						return k.answerUuid;
					});
					setRatingIds(answerUuids);
					notificationDataLoading(false);
					// setClarify(false);
					setEdit(false)
					notificationsDataRecommend(res.data.data);
					getSelectedAnswer(res.data.data.answers);
					getAnswerRatingsInNotificationAction(answerUuids.toString(), "").then(
						(res) => {
							if (res !== undefined && res.data.success === true) {
								setRatings(res.data.data);
								updateSearchData2(res.data.data)
							}
						}
					);
					setValue(res.data.data.question);
					setAdditional(res.data.data.additionalContext);
					res.data.data.answers.filter((ans) => {
						userUuid.push(ans.expertUuid);
						if (ans.attachments.length > 0) {
							ans.imageAttachments = ans.attachments.filter((attachment) => {
								if (
									attachment.name.includes(".png") ||
									attachment.name.includes(".jpg") ||
									attachment.name.includes(".jpeg") ||
									attachment.name.includes(".JPEG") ||
									attachment.name.includes(".JPG") ||
									attachment.name.includes(".PNG")
								) {

									return attachment;
								}
							});
						} else {
							ans.imageAttachments = [];
						}
						if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
							getInlineImage(ans.inlineImages)
								.then((res2) => {
									if (res2 !== undefined && res2.data.success) {
										let inlineDatas = res2.data.data;
										for (let i = 0; i < ans.inlineImages.length; ++i) {
											if (ans.inlineImages[i].includes(".png")) {
												let replacedContent = `[content|${
												  ans.inlineImages[i].split(".")[0]
												}|]`;
												let imgTag = `<img style='max-width:50%' src=${
												  res2.data.data[ans.inlineImages[i]]
												}></img>`;
												ans.answer = ans.answer.replace(
												  replacedContent,
												  imgTag
												);
												// dispatch(res.data.data[0].searchData);
											  }
											  else 
											  {
												let imgTag = `<img style='max-width:50%' src=${
													res2.data.data[ans.inlineImages[i]]
												  }></img>`;
												  let replacedContent = ans.inlineImages[i];
												  ans.answer = ans.answer.replace(
													ans.inlineImages[i],
													imgTag
												  );
											  }
											}
										setAllInlineImages({ ...allInlineImages, inlineDatas });
									}
								})
								.catch((err) => {
									console.log(err);
								});
						}
					});
					notificationsDataRecommend(res.data.data);
					getExpertsProfilePics(userUuid, undefined);
				} else {
					if (res === undefined) {
						navigate(`${Home_PAGE_URL}`);
					}
				}
			});
		} else if (recommedState.recommendPayload.isUrlRedirection !== undefined) {
			notificationDataLoading(true);
			let userUuid = [];
			if (recommedState.recommendPayload.type === 'open') {
				URLOpenDerectionData(recommedState.recommendPayload.quesUuid).then((res) => {
					if (res !== undefined && res?.data?.success) {
						if (recommedState.recommendPayload.type === 'open') {
							setIsShowAnswerButton(true);
						}
						if (res.data.data.length === 0) {
							// toast.warning("Question is not in your queue anymore!", {
							//   position: toast.POSITION.TOP_RIGHT,
							// });
							toast.warning(questionNotInYourQueue("Question is not in your queue anymore!"), {
								position: toast.POSITION.TOP_RIGHT,
							});
							updatePageNumberExpertOpenTab(0)
							navigate('/expertHome/open');
							return
						}
						res.data.data[0].question = res.data.data[0].questionText;
						notificationDataLoading(false);
						// setClarify(false);
						setEdit(false)
						notificationsDataRecommend(res.data.data[0]);
						getSelectedAnswer([]);
						setValue(res.data.data[0].questionText);
						setAdditional(res.data.data[0].additionalContext);
						// res.data.data[0].answers.filter((ans) => {
						//   userUuid.push(ans.expertUuid);
						//   if (ans.attachments.length > 0) {
						//     ans.imageAttachments = ans.attachments.filter((attachment) => {
						//       if (
						//         attachment.name.includes(".png") ||
						//         attachment.name.includes(".jpg") ||
						//         attachment.name.includes(".jpeg")
						//       ) {

						//         return attachment;
						//       }
						//     });
						//   } else {
						//     ans.imageAttachments = [];
						//   }
						//   if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
						//     getInlineImage(ans.inlineImages)
						//       .then((res2) => {
						//         if (res2 !== undefined && res2.data.success) {
						//           let inlineDatas = res2.data.data;
						//           setAllInlineImages({ ...allInlineImages, inlineDatas });
						//         }
						//       })
						//       .catch((err) => {
						//         console.log(err);
						//       });
						//   }
						// });
						notificationsDataRecommend(res.data.data[0]);
						getExpertsProfilePics(userUuid, undefined);
					} else {
						if (res.data === undefined) {
							navigate(`${Home_PAGE_URL}`);
						}
					}
				});
			} else {
				URLDerectionData(recommedState.recommendPayload.quesUuid).then((res) => {
					if (res !== undefined && res?.data?.success) {
						if (recommedState.recommendPayload.type === 'open') {
							setIsShowAnswerButton(true);
						}
						let answerUuids = res.data.data.answers.map((k, i) => {
							return k.answerUuid;
						});
						setRatingIds(answerUuids);
						notificationDataLoading(false);
						// setClarify(false);
						setEdit(false)
						notificationsDataRecommend(res.data.data);
						getSelectedAnswer(res.data.data.answers);
						getAnswerRatingsInNotificationAction(answerUuids.toString(), "").then(
							(res) => {
								if (res !== undefined && res.data.success === true) {
									setRatings(res.data.data);
									updateSearchData2(res.data.data)
								}
							}
						);
						setValue(res.data.data.question);
						setAdditional(res.data.data.additionalContext);
						if (res.data.data.seekerAttachments && res.data.data.seekerAttachments !== null) {
							getSeekerAttachmentsForReccommend(res.data.data.seekerAttachments)
						}
						res.data.data.answers.filter((ans) => {
							userUuid.push(ans.expertUuid);
							if (ans.attachments.length > 0) {
								ans.imageAttachments = ans.attachments.filter((attachment) => {
									if (
										attachment.name.includes(".png") ||
										attachment.name.includes(".jpg") ||
										attachment.name.includes(".jpeg") ||
										attachment.name.includes(".JPEG") ||
										attachment.name.includes(".JPG") ||
										attachment.name.includes(".PNG")
									) {

										return attachment;
									}
								});
							} else {
								ans.imageAttachments = [];
							}
							if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
								getInlineImage(ans.inlineImages)
									.then((res2) => {
										if (res2 !== undefined && res2.data.success) {
											let inlineDatas = res2.data.data;
											for (let i = 0; i < ans.inlineImages.length; ++i) {
												if (ans.inlineImages[i].includes(".png")) {
													let replacedContent = `[content|${
													  ans.inlineImages[i].split(".")[0]
													}|]`;
													let imgTag = `<img style='max-width:50%' src=${
													  res2.data.data[ans.inlineImages[i]]
													}></img>`;
													ans.answer = ans.answer.replace(
													  replacedContent,
													  imgTag
													);
													// dispatch(res.data.data[0].searchData);
												  }
												  else 
												  {
													let replacedContent = ans.inlineImages[i];
													let imgTag = `<img style='max-width:50%' src=${
														res2.data.data[ans.inlineImages[i]]
													  }></img>`;
													ans.answer = ans.answer.replace(replacedContent,imgTag)
												  }
												}
											setAllInlineImages({ ...allInlineImages, inlineDatas });
										}
									})
									.catch((err) => {
										console.log(err);
									});
							}
						});
						notificationsDataRecommend(res.data.data);
						getExpertsProfilePics(userUuid, undefined);
					} else {
						if (res.data === undefined) {
							navigate(`${Home_PAGE_URL}`);
						}
					}
				});
			}
		} else {
			const payload = {
				id: recommedState.recommendPayload.data.id,
				text: recommedState.recommendPayload.data.text,
			};
			let userUuid = [];
			notificationDataLoading(true);
			recommendQuestionData(payload).then((res) => {
				if (res === undefined) return;
				if (res.data.data[0].details === null) {
					toast.warning(successfulQuestionUpdated("Question has been moved out of your queue. --This QA has been updated. Please refresh to see the latest!"), {
						position: toast.POSITION.TOP_RIGHT,
					});
					navigate("/seekerHome/");
					return;
				}
				if (res !== undefined && res.data.success) {
					setRecommendation(res.data.data[0].recommendations);
					getRecommendationsData(res.data.data[0].recommendations);
					let answerUuids = res.data.data[0].details.answers.map((k, i) => {
						return k.originalAnswerUuid;
					});
					let docUuids = res.data.data[0].details.answers.map((k, i) => {
						return k.docId;
					});
					setDocIds(docUuids);
					setRatingIds(answerUuids);
					notificationDataLoading(false);
					// setClarify(false);
					setEdit(false)
					notificationsDataRecommend(res.data.data[0].details);
					getSelectedAnswer(res.data.data[0].details.answers);
					getAnswerRatingsInNotificationAction(
						answerUuids.toString(),
						docUuids.toString()
					).then((res1) => {
						if (res1 !== undefined && res1.data.success === true) {
							setRatings(res1.data.data);
							updateSearchData2(res1.data.data)
						}
					});
					setValue(res.data.data[0].details.question);
					setAdditional(res.data.data[0].details.additionalContext);
					res.data.data[0].details.answers.filter((ans) => {
						ans.attachmentURL = []
						if (res.data.data[0].details.reusableThreadQA) {
							ans.threadAttachments.unshift([]);
							ans.threadAttachments.unshift([]);
						}
						userUuid.push(ans.expertUuid);
						if (ans.answer.includes("vizsep")) {
							ans.threadAttachmentsURL = [];
							ans.threadAttachments.filter((att1) => {
								if (att1.length === 0) {
									ans.threadAttachmentsURL.push([]);
								} else {
									let asdffgh = [];
									att1.filter((att2) => {
										if (
											att2.name.includes(".jpeg") ||
											att2.name.includes(".jpg") ||
											att2.name.includes(".png") ||
											att2.name.includes(".JPEG") ||
											att2.name.includes(".JPG") ||
											att2.name.includes(".PNG")
										) {
											let payload = { name: att2.name };
											getAttachmentShowURL(payload)
												.then((res1) => {
													if (res1 === undefined) {
														return;
													}
													asdffgh.push(res1.data.data);
													ans.attachmentURL.push(res1.data.data)
												})
												.catch((err) => {
													handleError(err);
												});
										}
									});
									ans.threadAttachmentsURL.push(asdffgh);
								}
							});
						}
						if (ans.attachments.length > 0) {
							ans.imageAttachments = ans.imageAttachments =
								ans.attachments.filter((attachment) => {
									if (
										attachment.name.includes(".png") ||
										attachment.name.includes(".jpg") ||
										attachment.name.includes(".jpeg") ||
										attachment.name.includes(".JPEG") ||
										attachment.name.includes(".JPG") ||
										attachment.name.includes(".PNG")
									) {
										let payload = { name: attachment.name };
										getAttachmentShowURL(payload)
											.then((res1) => {
												if (res1 === undefined) {
													return;
												}
												// asdffgh.push(res1.data.data);
												ans.attachmentURL.push(res1.data.data)
											})
											.catch((err) => {
												handleError(err);
											});
										return attachment;
									}
									// if(attachment.name.toLowerCase().includes('.mp4') || attachment.name.toLowerCase().includes('.mov') || attachment.name.toLowerCase().includes('.mkv'))
									// {

									// }
								});
						}
						else {
							ans.imageAttachments = [];
							if (ans.attachments.length > 0) {
								ans.attachments.filter((obj) => {
									if (obj.attachment.name.toLowerCase().includes('.mp4') || obj.attachment.name.toLowerCase().includes('.mov') || obj.attachment.name.toLowerCase().includes('.mkv')) {
										let payload = [obj.name];
										instance
											.post(GET_FILES, payload)
											.then((res1) => {
												if (res1 === undefined) {
													return;
												}
												obj.objectUrl = res1.data.data[obj.name];
												// refreshTrendingData("refreshed");
											})
											.catch((err) => {
												handleError(err);
											});
									}
								})
							}
						}
						if(ans.answer.includes('content') && ans.inlineImages.length === 0)
						{
							let newAnswer = ans.answer.replace(/\[content\|\d+\|\]/g, '');
							ans.answer = newAnswer;
						}
						if (ans.inlineImages !== null && ans.inlineImages.length > 0) {
							getInlineImage(ans.inlineImages)
								.then((res2) => {
									if (res2 !== undefined && res2.data.success) {
										let inlineDatas = res2.data.data;
										for (let i = 0; i < ans.inlineImages.length; ++i) {
										if (ans.inlineImages[i].includes(".png")) {
											let replacedContent = `[content|${
											  ans.inlineImages[i].split(".")[0]
											}|]`;
											let imgTag = `<img style='max-width:50%' src=${
											  res2.data.data[ans.inlineImages[i]]
											}></img>`;
											ans.answer = ans.answer.replace(
											  replacedContent,
											  imgTag
											);
											// dispatch(res.data.data[0].searchData);
										  }
										  else 
										  {
											let replacedContent = ans.inlineImages[i];
											let imgTag = `<img style='max-width:50%' src=${
												res2.data.data[ans.inlineImages[i]]
											  }></img>`;
											ans.answer = ans.answer.replace(replacedContent,imgTag)
										  }
										}
										setAllInlineImages({ ...allInlineImages, inlineDatas });
									}
								})
								.catch((err) => {
									console.log(err);
								});
						}
					});
					notificationsDataRecommend(res.data.data[0].details);
					getExpertsProfilePics(userUuid, undefined);
				}
			});
		}
	};

	const renderAttachemnt = (arr) => {
		return (
			<div>
				{arr.map((item, index) => (
					<div className="mb-1">
						{" "}
						<AttachmentBox attachment={item} />
					</div>
				))}
			</div>
		);
	};

	const onClickAttachmentButton = () => {

	}

	const onClickAnswerNow = (data) => {
		questionDataForEditor(data);
		updateAttachmentForEditor(data.attachments)
		updateSubmissionTypeForEditor('answer');
		if (data.seekerAttachments && data.seekerAttachments !== null) {
			getSeekerAttachment(data.seekerAttachments)
		}
		getQuestionDraftData(data.questionUuid).then(res => {
			if (res === undefined) return;
			if (res.data.data.length > 0) {
				updateAnswerTextForEditor(res.data.data[0].answer);
				navigate('/expertHome/editor');
			} else {
				updateAnswerTextForEditor('');
				navigate('/expertHome/editor');
			}
		})
	}

	const onChangeTextAreaContent = (e) => {
		e.preventDefault();
		setValue(e.target.value);
	};
	const onChangeAddiText = (e) => {
		setAdditional(e.target.value);
	};

	const buttonStylesCancel = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
		color: 'black',
		border: '1px solid rgb(224, 226, 230)',
		height: '40px',
		minWidth: '88px',
		background: '#fff',
		marginBottom: '14px',
	}

	const buttonStyles = {
		padding: '8px 12px',
		borderRadius: '6px',
		fontSize: '14px',
		lineHeight: '24px',
		fontWeight: 400,
		boxShadow: 'rgba(16, 24, 40, 0.05) 0px 1px 2px 0px',
		color: 'rgb(255, 255, 255)',
		border: '1px solid rgb(255, 255, 255)',
		height: '40px',
		minWidth: '88px',
		background: 'linear-gradient(90.39deg, rgb(0, 209, 255) 0.34%, rgb(0, 117, 255) 99.7%)',
		marginBottom: '14px',
		// opacity: (editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext) ? '0.34' : null,
		// opacity:data.clarificationStatus ? ((data.text === editQuestion && data.additionalContext === addditionalContext) || editQuestion === '') ? '0.34' : (editQuestion === '') ? '0.34' : null : false,
		// cursor:(editQuestion === '' || data.text === editQuestion || data.additionalContext === addditionalContext || data.additionalContext === '')  ? 'not-allowed' : 'pointer'
		opacity: isButtonDisabled ? '0.34' : null,
		cursor: isButtonDisabled ? 'not-allowed' : 'pointer'
	}

	const onclickUpdateQ = () => {
		let obj = {
			questionUuid: data.questionUuid,
			questionText: val,
			domain: data.domain,
			postedDate: data.postedTimestamp,
			additionalContext: additional,
		};
		editQuestionText(obj).then((res) => {
			if (res !== undefined) {
				data.question = val;
				data.clarificationStatus = false;
				data.additionalContext = additional;
				// setClarify(false);
				setEdit(false)
				setClarified(true)
				if (res.data.data !== undefined || res.data.success) {
					toast.success(successfulQuestionUpdated(res.data.message), {
						position: toast.POSITION.TOP_RIGHT,
					});
				}
			}
		});
	};

	const renderClarificationsCard = () => {
		return (
			<>
				{data.clarifications && data.clarifications.length > 0 && (
					<>
						<div style={{
							background: "rgb(249, 237, 229)",
							padding: "5px 10px",
							borderRadius: "4px",
							marginBottom: "12px",
						}}>
							<span class="clarificationHeading">Clarification request from expert <span class="clarificationHeadingSubText">(Clarify question to allow an expert to provide the best answer)</span></span>
							<ul>
								{data.clarifications.map((obj, ind) => {
									return (
										<li style={{ listStyleType: "square" }} key={ind}>
											<div
												dangerouslySetInnerHTML={{
													__html: replaceContentEditableText(obj.context),
												}}
											/>
										</li>
									)
								})}
							</ul>
						</div>
					</>
				)}
				<div style={textStyles}>
					<textarea wrap="hard" style={{ width: '100%', border: '1px solid rgb(224, 226, 230)', outline: 'none', padding: '12px', borderRadius: '6px', resize: 'none' }} value={val} onChange={(e) => onChangeTextAreaContent(e)} />
				</div>
				{
					data.seekerAttachments && data.seekerAttachments.length > 0 && edit &&
					<div style={{ marginTop: '10px', width: '52px' }}>
						{
							<Popover title={renderAttachemnt(data.seekerAttachments)}>
								{" "}
								<Button2 onClickFunc={onClickAttachmentButton}>
									<DownloadIcon />
								</Button2>
							</Popover>
						}
					</div>
				}
				<span style={{
					color: "rgb(92, 102, 123)",
					fontWeight: 400,
					fontSize: "14px",
					marginTop: "5px",
					marginBottom: "5px",
				}}>Asked{" "}{momentit(data.postedTimestamp)}</span>
				<Tags isShowAnswerButton={isShowAnswerButton} data={data} edit={edit} setEdit={setEdit} clarified={clarified} />
				<span style={{
					color: "rgb(92, 102, 123)",
					fontWeight: 400,
					fontSize: "14px",
					marginTop: "5px",
					marginBottom: "5px",
				}}>Additional Context(optional)</span>
				<textarea wrap="hard" style={{ width: '100%', border: '1px solid rgb(224, 226, 230)', outline: 'none', padding: '12px', borderRadius: '6px', resize: 'none' }} value={additional} onChange={(e) => onChangeAddiText(e)} />
				<div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '12px' }}>
					<Button style={buttonStylesCancel} onClick={() => onChangeCancel()}>Cancel</Button>
					<Button
						disabled={isButtonDisabled}
						style={buttonStyles} onClick={() => onclickUpdateQ()}>Update</Button>
				</div>
			</>
		)
	}



	useEffect(() => {
		if (recommedState.recommendPayload === null) {
			navigate(`${Home_PAGE_URL}`);
			return;
		}
		callApi();
	}, [recommedState.recommendPayload]);

	const onClickButton = () => {
	}

	const onRateActionToastMessage = (message) => {
		return (
			<span style={{ fontSize: '12px' }}>{message}</span>
		)
	}

	const onClickFeedback = (answerUuid, rating, feedback, data, docId) => {
		let obj = {
			// ...(docId === undefined && {answerUuid:answerUuid}),
			answerUuid: data.originalAnswerUuid === undefined ? null : data.originalAnswerUuid,
			docId: data.originalAnswerUuid === undefined ? data.docId : null,
			feedback: feedback,
			rating: rating[data.docId === undefined ? data.originalAnswerUuid : data.docId].rating,
			...(docId !== undefined && { docId: docId })
		}
		// console.log(obj, 'check object')
		rateRecommandedAnswer(obj).then((res1) => {
			if (res1 !== undefined && res1.data.success) {
				getAnswerRatingsInNotificationAction(
					ratingIds.toString(),
					docIds.toString()
				).then((res) => {
					if (res !== undefined && res.data.success === true) {
						setRatings(res.data.data);
						updateSearchData2(res.data.data)
						toast.success(
							onRateActionToastMessage(res1.data.message), {
							position: toast.POSITION.TOP_RIGHT
						}
						)
					}
				});
			}
		});
	}

	const sendToHomePage = () => {
		// console.log("editor", editorState.pageNumber)
		if (recommedState.recommendPayload.isUrlRedirection === undefined || recommedState.recommendPayload.type === 'editor') {
			let preserved = recommedState.prevData;
			preserved.pop();
			    
			if(editorState.pageNumber==0){
				updatePageNoAnswered( editorState.pageNumber)
				updateRatingBoolean(true)
			  }
			  else {
				updateRatingBoolean(true)
				AnsweredPageBool(!editorState.answeredBoolean);
			  }
			// console.log(preserved, 'check preserved')
			preservePreviousRecommendData(preserved);
			if (preserved.length > 0) {
				recommendData(preserved[preserved.length - 1]);
			}
			isBackClickedOnRecommend(true);
			setTimeout(() => {
				isBackClickedOnRecommend(false);
				// updatePageNoAnswered( editorState.pageNumber)
			}, 3000);
			navigate(-1);
			if(editorState.pageNumber!==0){
				updatePageNoAnswered( editorState.pageNumber)
				updateRatingBoolean(true)
			  }else {
				updateRatingBoolean(true)
				AnsweredPageBool(!editorState.answeredBoolean);
			  }

			// console.log('check if it going inside this condition')
		} else {
			navigate(`${Home_PAGE_URL}`);
			
			  updateRatingBoolean(true)
			updatePageNoAnswered( editorState.pageNumber)
			
		}

		// setTimeout(() => {
		// 	// isBackClickedOnRecommend(false);
		// 	updatePageNoAnswered( editorState.pageNumber)
		// 	// AnsweredPageBool(!editorState.answeredBoolean);
		//   }, 1000);
	
	};

	const onChangeCancel = () => {
		setEdit(false);
		setValue(questionText);
		setAdditional(data.additionalContext);
	};


	const onClickCancel = () => {
		// setClarify(!clarify)
		setEdit(!edit)
		setClarificationTextExpert('')
	}/* For Expert  clarification cancel*/

	const onChangeClarificationText = (e) => {
		setClarificationTextExpert(e.target.value);
	}

	const renderClatifyCardForExpertRole = () => {
		return (
			<>
				<div>
				<div style={textStyles}>{data.question}</div>
					<div style={{marginTop:'5px',marginBottom:'5px'}}></div>
					<span style={{ fontSize: "14px" }}></span>
					<textarea placeholder="Ask your clarification to question here" value={clarificationTextExpert} onChange={(e) => onChangeClarificationText(e)} rows={5} style={{ width: "100%", fontSize: "14px", outline: "none", border: "1px solid lightgray", padding: '12px', resize: 'none', borderRadius: '6px' }} />
					{/* <button className="btn-warning submitButtonExpert" disabled={clarificationTextExpert === '' ? true : false} onClick={() => onClickSubmitClarificationExpertRole()} >Submit</button> */}
					<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
						<Button3 type={'secondary'} disabled={false} onClickFunc={onClickCancel} text={'Cancel'} />
						{clarificationTextExpert === '' ? <>
							<span style={{ opacity: '0.5', pointerEvents: 'none' }}>
								<Button3 disabled={true} text={'Submit'} onClickFunc={onClickButton} type={'primary'} /></span></>
							: <><Button3 disabled={false} type={'primary'} text={'Submit'} onClickFunc={onClickSubmitClarificationExpertRole} /></>}
					</div>
				</div>
			</>
		)
	}

	const onClickSubmitClarificationExpertRole = () => {
		const payload = {
			clarificationQuestion: clarificationTextExpert,
			questionUuidStr: data.questionUuid
		}
		askClarificationExpert(payload).then((res) => {
			if (res === undefined) return;
			if (res.data.success || res.data.data !== '') {
				// setClarify(!clarify);
				setEdit(!edit)
				setClarificationTextExpert('');
				// setIsShowAnswerButton(false);
				// data.clarificationStatus = !data.clarificationStatus;
				if(data.docId && data.docId !== '')
				{
				setShowButtons(true);
				}
				data.clarificationStatus = true;
				toast.success(successfulClarificationQuestion(), {
					position: toast.POSITION.TOP_RIGHT,
				});
			}
		})
	}

	const onClickModalReroute = (data) => {
		const domainId = userState.expertTopics.filter((obj) => {
			if (obj.name === data.domain) {
				return obj;
			}
		});
		getDomainOfQuestion(data.domain);
		getSelectedQuestionDataExpert(data.questionUuid);
		FetchForceReroute(data.questionUuid, domainId[0].indexId).then((res) => {
			if (res === undefined) return;
			if (res.data.success === true || res.data.data !== '') {
				advanceFilterModalToggle({ bool: true, value: "rerouteModal" })
				getForceRerouteUsersStatus(res.data.data);
			}
		})
	}


	/* Answer Block code starts here */
	const Answer = ({ data, question, val }) => {
		const [messageApi, contextHolder] = message.useMessage();
		const [feedback, setFeedBack] = useState('');
		const randomNumber = Math.random() * 10;
		const [isShow, setShow] = useState(false);

		const dispatch = useDispatch();
		const { advanceFilterModalToggle, getSelectedQuestion, getSelectedAnswer ,updatePageNoAnswered} = bindActionCreators(Actions, dispatch)
		const successfulHelpful = (message) => {
			return (
				<>
					<span style={{ fontSize: "12px" }}>{message}</span>
				</>
			);
		};
		const onClickRFU = () => {
			advanceFilterModalToggle({ bool: true, value: "followUpModal" });
			getSelectedAnswer(data);
			getSelectedQuestion(question);
			if (question.seekerAttachments) {
				getSeekerAttachmentsForAnswered(question.seekerAttachments)
			}
		};
		const stripHtml = (htmlString) => {
			return htmlString
				.replace(/<br\s*\/?>/gi, "\n")
				.replace(/<\/p>/gi, "\n\n")
				.replace(/<\/?[^>]+(>|$)/g, "");
		}
		const success = () => {
			messageApi.info("hl");
		};
		const onClickCopy = (text) => {
			toast.success(successfulHelpful("Text copied!"), {
				position: toast.POSITION.TOP_RIGHT,
			});
			let newString = stripHtml(data.answer);
			navigator.clipboard.writeText(`${question.text}\n\n${newString}`);
		}
		const onClickPlayPause = () => {
			setPlay(!isPlay);
			// if(isPlay){
			//   document.getElementById(`${question.questionUuid}_${randomNumber}`).pause();
			// }else{
			//   document.getElementById(`${question.questionUuid}_${randomNumber}`).play();
			// }
		}

		const firstThread = {
			width: "95%",
			minHeight: "44px",
			border: "1px solid rgb(224, 226, 230)",
			padding: "10px 12px",
			borderRadius: "8px",
			background: "rgb(246, 247, 248)",
			color: "rgb(42, 54, 74)",
			fontSize: "16px",
			lineHeight: "24px",
			fontWeight: 300,
			marginLeft: "5%",
			marginBlock: "5px",
			wordBreak: 'break-word',overflowWrap: 'break-word',
		};

		const replyThread = {
			width: "85%",
			minHeight: "44px",
			border: "1px solid rgb(224, 226, 230)",
			padding: "10px 12px",
			borderRadius: "8px",
			background: "rgb(255, 255, 255)",
			color: "rgb(92, 102, 123)",
			fontSize: "16px",
			lineHeight: "24px",
			fontWeight: 300,
			marginLeft: "15%",
			marginBottom: "5px",
			wordBreak: 'break-word',overflowWrap: 'break-word',
		};

		const buttonDarkStyle = {
			minWidh: '96px',
			border: '1px solid #E0E2E6',
			padding: '8px 16px 8px 16px',
			borderRadius: '8px',
			boxShadow: ' 0px 1px 2px 0px #1018280D',
			fontSize: '14px',
			color: '#2A364A',
			// marginRight:'8px',
			background: '#F6F7F8',
			fontWeight: '400',
			cursor: 'pointer',
			display: 'flex',
			alignItems: 'center',
			cursor: 'not-allowed',
			opacity: '0.7'
		}

		const onClickDisabledButton = () => {

		}

		return (
			<>
				{data.attachmentVideo && data.attachmentVideo.length > 0 && (
					<>
						<div className="mt-1" style={{ textAlign: 'right' }}><Button type={'primary'} text={isPlay ? 'Hide Video' : 'Show Video'} onClickFunc={onClickPlayPause} /></div>
						{isPlay && <div className="mb-4 mt-3" style={{ textAlign: 'center' }}>
							<div>
								<video
									id={`${question.questionUuid}_${randomNumber}`}
									controls
									onBlur={() => handlePauseAllVideo()}
									style={contentStyle}
								>
									<source
										src={`${data.attachmentVideo[0].objectUrl}#t=${data.startTime},${data.endTime}`}
										type="video/mp4"
									/>
								</video>
							</div>
						</div>}
					</>
				)}
				{data.attachmentURL && data.attachmentURL.length > 0 && (
					<div className="mb-4 mt-3">
						<div>
							<ImgCarousal data={data.attachmentURL} />
						</div>
					</div>
				)}
				{
					data.answer !== null && data.answer.includes('vizsep') &&
					// <Thread type={'thread'} thread={data.threads} isShow={isShow} isReusable={question.threadType === 'REUSABLE_THREAD_QA' ? true : false} />
					(
						<>
							<div style={firstThread} dangerouslySetInnerHTML={{ __html: data.answer !== null && data.answer.split('vizsep') && data.answer.split('vizsep')[0] }} />
							{question.reusableThreadQA && (
								<>
									<div style={firstThread} dangerouslySetInnerHTML={{ __html: data.answer.split('vizsep') && data.answer.split('vizsep')[1] }} />
								</>
							)}
							{/* {data.answer.split('vizsep').map((obj,ind)=>{
              if(ind !== 0)
              {
                return(<div style={replyThread}>{obj}</div>)
              }
            })} */}
							{
								data.answer !== null && question.reusableThreadQA === false && data.answer.includes('vizsep') && data.answer.split('vizsep')[1] &&
								(
									<div style={replyThread} dangerouslySetInnerHTML={{ __html: data.answer.split('vizsep')[1] }} />
								)
							}
						</>
					)
				}
				{
					data.answer !== null && data.answer.includes('vizsep') && !isShow &&
					(
						<span style={showThreadStyles} onClick={() => setShow(!isShow)}>Show full thread <ArrowDownIcon /></span>
					)
				}
				{
					data.answer !== null && data.answer.includes('vizsep') && data.answer.split('vizsep').length > 0 && isShow && (
						<>
							{data.answer.split('vizsep').map((obj, ind) => {
								if (ind !== 0 && ind !== 1) {
									return (
										<div style={replyThread} key={ind} dangerouslySetInnerHTML={{ __html: obj }} />
									)
								}
							})}
							<span style={showThreadStyles} onClick={() => setShow(!isShow)}>Hide full thread <ArrowUpIcon /></span>
						</>
					)
				}
				{!data.answer.includes('vizsep') && <div
					style={ansStyles}
					dangerouslySetInnerHTML={{
						__html: !isShow
							? removeStylesFromHtml(
								trimString(
									data.answer === null
										? question.contextData
										: data.answer
								)
							)
							: removeStylesFromHtml(
								data.answer === null
									? question.contextData
									: data.answer
							),
					}}
				></div>}
				{
					data.url && (
						<>
							<span style={{ fontSize: '13px' }}>URL: <a target={"_blank"} href={data.url}>{data.url}</a></span>
						</>
					)
				}
				{data.attachments && data.attachments.length > 0 &&
					data.attachments.map((attachment, index) => {
						if (attachment.name.toLowerCase().includes(".mp4") || attachment.name.toLowerCase().includes(".mov") || attachment.name.toLowerCase().includes(".mkv")) {
							return (
								<div style={{ textAlign: "center" }}>
									<video
										style={{ width: "70%" }}
										id={data.answerUuid}
										controls
										onBlur={() => handlePauseAllVideo()}
									>
										<source src={attachment.objectUrl} />
									</video>
								</div>
							);
						}
					})}
				{/* {data.attachments && data.attachments.length > 0 } */}
				<div
					style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						marginTop: "10px",
					}}
				>
					<div>
						{data.answer !== null
							? data.answer.length > 350 &&
							!isShow && !data.answer.includes('vizsep') && (
								<div onClick={() => setShow(!isShow)} style={showMoreStyles}>
									Show more&nbsp;
									<ArrowDownIcon />
								</div>
							)
							: question.contextData.length > 350 &&
							!isShow && (
								<div onClick={() => setShow(!isShow)} style={showMoreStyles}>
									Show more&nbsp;
									<ArrowDownIcon />
								</div>
							)}
						{data.answer !== null
							? data.answer.length > 350 &&
							isShow && !data.answer.includes('vizsep') && (
								<div onClick={() => setShow(!isShow)} style={showMoreStyles}>
									Show less&nbsp;
									<ArrowUpIcon />
								</div>
							)
							: question.contextData.length > 350 &&
							isShow && (
								<div onClick={() => setShow(!isShow)} style={showMoreStyles}>
									Show less&nbsp;
									<ArrowUpIcon />
								</div>
							)}
					</div>
					{
						<div style={{ display: "flex", alignItems: "center", gap: '5px' }}>
							{CURRENT_ROLE === 'Seeker' && data.answerStatus !== "accepted" &&
								origData.postedUserUuid === userState.geoAttributes.userId &&
								ratings !== null &&
								ratings[
								data.originalAnswerUuid === undefined
									? data.docId
									: data.originalAnswerUuid
								] !== undefined &&
								ratings[
									data.originalAnswerUuid === undefined
										? data.docId
										: data.originalAnswerUuid
								].rating === null &&
								ratings[
									data.originalAnswerUuid === undefined
										? data.docId
										: data.originalAnswerUuid
								].feedback === null && (
									<>
										{data.userInitiatedCuration ? <>
											<div style={{ opacity: 0.5, pointerEvents: 'none', fontWeight: 400, fontSize: '14px' }}>
												<Button2 type={"dark"} disabled={true} onClickFunc={onClickDisabledButton}>
													<RFUIcon style={{ marginRight: '5px' }} />
													Request Follow-Up</Button2></div></> : <Button2 type={"dark"} onClickFunc={onClickRFU}>
											<RFUIcon />
											&nbsp;Request Follow-Up
										</Button2>}
									</>
								)}
							{ratings !== null &&
								ratings[
								data.originalAnswerUuid === undefined
									? data.docId
									: data.originalAnswerUuid
								] !== undefined && (
									<>
										<Button2 onClickFunc={onClickButton}>
											{/* <Rating id={data.docId === undefined ? data.answerUuid : data.docId} /> */}
											<Rating id={data.originalAnswerUuid === undefined
												? data.docId
												: data.originalAnswerUuid} />
										</Button2>
									</>
								)}
						</div>
					}
				</div>
				{
					CURRENT_ROLE === 'Seeker' && ratings !== null &&
					ratings[
					data.originalAnswerUuid === undefined
						? data.docId
						: data.originalAnswerUuid
					] !== undefined &&
					ratings[
						data.originalAnswerUuid === undefined
							? data.docId
							: data.originalAnswerUuid
					].rating !== null &&
					ratings[
						data.originalAnswerUuid === undefined
							? data.docId
							: data.originalAnswerUuid
					].feedback === null && (
						<>
							<textarea style={{ width: '100%', marginTop: '10px', color: '#5C667B', fontFamily: 'inter', borderRadius: '6px', padding: '10px', border: '1px solid #E0E2E6', outline: 'none', resize: 'none' }} placeholder="Write your feedback..." value={feedback} onChange={(e) => setFeedBack(e.target.value)} />
							<div style={{ opacity: `${feedback.length == 0 ? '.5' : '1'}`, pointerEvents: `${feedback.length == 0 ? 'none' : 'auto'}` }}>
								<Button3 type={"primary"} text="Submit" onClickFunc={() => onClickFeedback(data.answerUuid, ratingState.ratings, feedback, data, data.docId)} />
							</div>
						</>
					)
				}
				{
					CURRENT_ROLE === 'Seeker' && ratings !== null &&
					ratings[
					data.originalAnswerUuid === undefined
						? data.docId
						: data.originalAnswerUuid
					] !== undefined &&
					ratings[
						data.originalAnswerUuid === undefined
							? data.docId
							: data.originalAnswerUuid
					].rating !== null &&
					ratings[
						data.originalAnswerUuid === undefined
							? data.docId
							: data.originalAnswerUuid
					].feedback !== null && (
						<>
							<span style={{ fontSize: '16px', fontWeight: 500 }}>Feedback:{" "}</span>
							<span style={{ fontSize: '16px' }}>{
								ratings[data.originalAnswerUuid === undefined ? data.docId : data.originalAnswerUuid].feedback
							}</span>
						</>
					)
				}
			</>
		);
	}

	/* Answer Block code ends here */

	return (
		<>
			{CURRENT_ROLE === 'Expert' &&
				<LayoutExpert>
					<div style={{ width: "74%", margin: "auto", marginTop: "1%", marginBottom: '7%' }}>
						{!keyTagState.isBack && <>
							<div className="midBlockNew">
								<h3 className="backButtonNew">
									<div style={{ display: 'flex' }} onClick={() => sendToHomePage()}>
										<i
											className="fa fa-arrow-left"
											aria-hidden="true"
											style={{
												padding: "3px",
												fontSize: "20px",
												paddingRight: "7px",
											}}
										></i>
										<span>Back</span>
									</div>
								</h3>
							</div>
							<div style={containerStyles}>
								{recommedState.isLoading && (
									<>
										<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
									</>
								)}
								{recommedState.isLoading === false &&
									(
										<>
											{edit === false && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
												<div style={textStyles}>
													{isShowAnswerButton && data.express && (
														<>
															{/* <img src={require('../../Icons/fire.svg')} style={{ width: '20px', height: '20px' }} /> */}
															<FireIcon style={{width:'20px',height:'20px',paddingRight:'3px',marginBottom:'4px'}} />
														</>
													)}
													{data.questionStatus === 'answered' && isShowAnswerButton && <FontDownloadIcon sx={{ marginRight: "3px",marginBottom:'4px' }} style={{
														color: "#BEDB39",
														fontSize: "22px"
													}} />}{data.question}
												</div>
												<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
													{data.answers &&
														data.answers.length === 0 &&
														edit !== true && CURRENT_ROLE === 'Seeker' && (
															<i
																className="fa fa-pencil-square-o"
																style={{
																	cursor: "pointer",
																	fontSize: '20px',
																	color:
																		data.clarificationStatus === true
																			? "#fd7400"
																			: "",
																	margin:
																		data.clarificationStatus === true
																			? "5px"
																			: "5px",
																}}
																onClick={() => setEdit(!edit)}
															></i>
														)}
													{/* Expert code conditional check start*/}
													{
														data.questionStatus !== 'answered' && !data.curationStatus && isShowAnswerButton &&
														edit !== true && CURRENT_ROLE === 'Expert' &&
														(
															<i className="fa fa-question-circle" style={{
																fontSize: '20px',
																cursor: "pointer", margin: "5px", color: data.clarificationStatus === true ? "#fd7400" : "lightgray"
															}} onClick={() => setEdit(!edit)}>
															</i>
														)
													}
													{/* Expert code conditional check end*/}
													{data.seekerAttachments && data.seekerAttachments.length > 0 && (
														<>
															<Popover title={renderAttachemnt(data.seekerAttachments)}>
																{" "}
																<Button2 onClickFunc={onClickAttachmentButton}>
																	<DownloadIcon />
																</Button2>
															</Popover>
														</>
													)}
													{
														recommendations && recommendations.length > 0 && (
															<>
																{/* <span style={{border:'1px solid #E0E2E6',borderRadius:'8px',fontSize:'14px',fontWeight:'500',color:'#2A364A',padding:'8px 16px',cursor:'pointer'}} onClick={()=>advanceFilterModalToggle({bool:true,value:'recommendModal'})}> */}
																<Button2 onClickFunc={() => advanceFilterModalToggle({ bool: true, value: 'recommendModal' })}>
																	Related&nbsp;<i class="fa fa-question-circle" style={{ color: '#2A364A', backgroundColor: 'white' }}></i>
																</Button2>
																{/* </span> */}
															</>
														)
													}
													{data.favourite ?
														<>
															<div style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite()}><HeartSelectedIcon /></div>
														</> :
														<>
															<div style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite()}><HeartIcon /></div>
														</>}
												</div>
											</div>}
											{edit === false && <span style={{
												color: "rgb(92, 102, 123)",
												fontWeight: 400,
												fontSize: "14px",
												marginTop: "5px",
												marginBottom: "5px",
											}}>Asked{" "}{momentit(data.postedTimestamp)}</span>}
											{
												data.additionalContext && data.additionalContext !== '' && edit === false && (
													<div style={{
														marginTop: '5px', marginBottom: '5px', border: "1px solid rgb(246, 247, 248)",
														marginBlock: "10px",
														borderRadius: "6px",
														background: "rgb(246, 247, 248)",
														padding: "12px",
													}}>{data.additionalContext}</div>
												)
											}
											{edit === false && (
												<Tags isShowAnswerButton={isShowAnswerButton} data={data} edit={edit} setEdit={setEdit} clarified={clarified} />
											)}
											{edit && CURRENT_ROLE === 'Seeker' && (
												renderClarificationsCard()
											)}
											{/* Conditional check for Expert role start */}
											{
												edit && CURRENT_ROLE === 'Expert' && (
													<>
														{renderClatifyCardForExpertRole()}
													</>
												)
											}
											{/* Conditional check for Expert role end */}
											{
												data.answers && data.answers.length > 0 && data.answers.map((obj, ind) => {
													return (
														<>
															<NameInfo data={obj} question={data} />
															<Answer data={obj} question={data} />
															{ind !== data.answers.length - 1 && <hr style={hrStyles} />}
														</>
													)
												})
											}
											{/* Conditional check for Expert role buttons start */}
											{CURRENT_ROLE === 'Expert' && isShowAnswerButton &&
												(data.questionStatus === 'answered' || data.questionStatus === 'open') && !edit &&
												(
													<>
														<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
															{userState.reroute &&
																// <RerouteButton onClick={() => onClickModalReroute(data)}><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</RerouteButton>
																<Button2  onClickFunc={() => onClickModalReroute(data)} type={'dark'} minWidth='140px' children={<span><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</span>}>
																</Button2>
															}
															{/* <DeclineButton onClick={() => onClickModalDecline()}><i className="fa fa-times" style={{ paddingRight: '5px' }}></i>Decline</DeclineButton> */}
															<Button2 minWidth={'140px'} onClickFunc={() => onClickModalDecline()} type={'dark'} children={<span><i className="fa fa-times" style={{ paddingRight: '5px' }} />Decline</span>} />
															{data.docId !== undefined ?
																// <VerifyNowButton onClick={() => onClickAnswerNow(data)} >Verify Now</VerifyNowButton>
																<Button3 minWidth={'140px'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-check" style={{ paddingRight: '5px' }} />Verify Now</span>} type={'primary'} />
																: data.userInitiatedCuration ?
																	// <UpdateAnswerButton onClick={() => onClickAnswerNow(data)} >Update Answer</UpdateAnswerButton>
																	<Button3 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span>
																		<i className="fa fa-lightbulb-o" style={{ paddingRight: '5px' }} />Update Answer
																	</span>} />
																	:
																	// <AnswerNowButton onClick={() => onClickAnswerNow(data)} ><i className="fa fa-comment-o" style={{ paddingRight: '5px' }}></i>Answer Now</AnswerNowButton>
																	<Button3 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-comments" style={{ paddingRight: '5px' }} />Answer Now</span>} />
															}
														</div>
													</>
												)
											}
											{/* Conditional check for Expert role buttons end */}
										</>
									)}
							</div>
						</>}
						{keyTagState.isBack && <KeyTagDataBox />}
					</div>
				</LayoutExpert>}
			{
				CURRENT_ROLE === 'Seeker' && (
					<Layout>
						<div style={{ width: "74%", margin: "auto", marginTop: "1%", marginBottom: '7%' }}>
							{!keyTagState.isBack && <>
								<div className="midBlockNew">
									<h3 className="backButtonNew">
										<div style={{ display: 'flex' }} onClick={() => sendToHomePage()}>
											<i
												className="fa fa-arrow-left"
												aria-hidden="true"
												style={{
													padding: "3px",
													fontSize: "20px",
													paddingRight: "7px",
												}}
											></i>
											<span>Back</span>
										</div>
									</h3>
								</div>
								<div style={containerStyles}>
									{recommedState.isLoading && (
										<>
											<Spin spinning={true} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} />
										</>
									)}
									{recommedState.isLoading === false &&
										(
											<>
												{edit === false && <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
													<div style={textStyles}>
														{isShowAnswerButton && data.express && (
															<>
																<img src={require('../../Icons/fire.svg')} style={{ width: '20px', height: '20px' }} />
															</>
														)}
														{data.questionStatus === 'answered' && isShowAnswerButton && <FontDownloadIcon sx={{ marginRight: "3px" }} style={{
															color: "#BEDB39",
															fontSize: "22px"
														}} />}{data.question}
													</div>
													<div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
														{data.answers &&
															data.answers.length === 0 &&
															edit !== true && CURRENT_ROLE === 'Seeker' && (
																<i
																	className="fa fa-pencil-square-o"
																	style={{
																		cursor: "pointer",
																		fontSize: '20px',
																		color:
																			data.clarificationStatus === true
																				? "#fd7400"
																				: "",
																		margin:
																			data.clarificationStatus === true
																				? "5px"
																				: "5px",
																	}}
																	onClick={() => setEdit(!edit)}
																></i>
															)}
														{/* Expert code conditional check start*/}
														{
															data.questionStatus !== 'answered' && !data.curationStatus && isShowAnswerButton &&
															edit !== true && CURRENT_ROLE === 'Expert' &&
															(
																<i className="fa fa-question-circle" style={{
																	fontSize: '20px',
																	cursor: "pointer", margin: "5px", color: data.clarificationStatus === true ? "#fd7400" : "lightgray"
																}} onClick={() => setEdit(!edit)}>
																</i>
															)
														}
														{/* Expert code conditional check end*/}
														{data.seekerAttachments && data.seekerAttachments.length > 0 && (
															<>
																<Popover title={renderAttachemnt(data.seekerAttachments)}>
																	{" "}
																	<Button2 onClickFunc={onClickAttachmentButton}>
																		<DownloadIcon />
																	</Button2>
																</Popover>
															</>
														)}
														{
															recommendations && recommendations.length > 0 && (
																<>
																	{/* <span style={{border:'1px solid #E0E2E6',borderRadius:'8px',fontSize:'14px',fontWeight:'500',color:'#2A364A',padding:'8px 16px',cursor:'pointer'}} onClick={()=>advanceFilterModalToggle({bool:true,value:'recommendModal'})}> */}
																	<Button2 onClickFunc={() => advanceFilterModalToggle({ bool: true, value: 'recommendModal' })}>
																		Related&nbsp;<i class="fa fa-question-circle" style={{ color: '#2A364A', backgroundColor: 'white' }}></i>
																	</Button2>
																	{/* </span> */}
																</>
															)
														}
														{data.favourite ?
															<>
																<div style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite()}><HeartSelectedIcon /></div>
															</> :
															<>
																<div style={{ cursor: 'pointer' }} onClick={() => onClickMarkFavorite()}><HeartIcon /></div>
															</>}
													</div>
												</div>}
												{edit === false && <span style={{
													color: "rgb(92, 102, 123)",
													fontWeight: 400,
													fontSize: "14px",
													marginTop: "5px",
													marginBottom: "5px",
												}}>Asked{" "}{momentit(data.postedTimestamp)}</span>}
												{
													data.additionalContext && data.additionalContext !== '' && edit === false && (
														<div style={{
															marginTop: '5px', marginBottom: '5px', border: "1px solid rgb(246, 247, 248)",
															marginBlock: "10px",
															borderRadius: "6px",
															background: "rgb(246, 247, 248)",
															padding: "12px",
														}}>{data.additionalContext}</div>
													)
												}
												{edit === false && (
													<Tags isShowAnswerButton={isShowAnswerButton} data={data} edit={edit} setEdit={setEdit} clarified={clarified} />
												)}
												{edit && CURRENT_ROLE === 'Seeker' && (
													renderClarificationsCard()
												)}
												{/* Conditional check for Expert role start */}
												{
													edit && CURRENT_ROLE === 'Expert' && (
														<>
															{renderClatifyCardForExpertRole()}
														</>
													)
												}
												{/* Conditional check for Expert role end */}
												{
													data.answers && data.answers.length > 0 && data.answers.map((obj, ind) => {
														return (
															<>
																<NameInfo data={obj} question={data} />
																<Answer data={obj} question={data} />
																{ind !== data.answers.length - 1 && <hr style={hrStyles} />}
															</>
														)
													})
												}
												{/* Conditional check for Expert role buttons start */}
												{CURRENT_ROLE === 'Expert' && isShowAnswerButton &&
													(data.questionStatus === 'answered' || data.questionStatus === 'open') && !edit && 
													(
														<>
															<div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
																{userState.reroute &&
																	// <RerouteButton onClick={() => onClickModalReroute(data)}><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</RerouteButton>
																	<Button3 onClickFunc={() => onClickModalReroute(data)} type={'secondary'} minWidth='140px' text={<span><i className="fa fa-repeat" style={{ paddingRight: '5px' }}></i>Reroute</span>}>
																	</Button3>
																}
																{/* <DeclineButton onClick={() => onClickModalDecline()}><i className="fa fa-times" style={{ paddingRight: '5px' }}></i>Decline</DeclineButton> */}
																<Button3 minWidth={'140px'} onClickFunc={() => onClickModalDecline()} type={'secondary'} text={<span><i className="fa fa-times" style={{ paddingRight: '5px' }} />Decline</span>} />
														{(data.docId !== undefined) ?
															// <VerifyNowButton onClick={() => onClickAnswerNow(data)} >Verify Now</VerifyNowButton>
															showButtons ?
																<Button3 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-comments" style={{ paddingRight: '5px' }} />Answer Now</span>} />
															:
															<Button3 minWidth={'140px'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-check" style={{ paddingRight: '5px' }} />Verify Now</span>} type={'primary'} />
															: data.userInitiatedCuration ?
																// <UpdateAnswerButton onClick={() => onClickAnswerNow(data)} >Update Answer</UpdateAnswerButton>
																<Button3 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span>
																	<i className="fa fa-lightbulb-o" style={{ paddingRight: '5px' }} />Update Answer
																</span>} />
																:
																	// <AnswerNowButton onClick={() => onClickAnswerNow(data)} ><i className="fa fa-comment-o" style={{ paddingRight: '5px' }}></i>Answer Now</AnswerNowButton>
																	<Button3 minWidth={'140px'} type={'primary'} onClickFunc={() => onClickAnswerNow(data)} text={<span><i className="fa fa-comments" style={{ paddingRight: '5px' }} />Answer Now</span>} />

														}
															</div>
														</>
													)
												}
												{/* Conditional check for Expert role buttons end */}
											</>
										)}
								</div>
							</>}
							{keyTagState.isBack && <KeyTagDataBox />}
						</div>
					</Layout>
				)
			}
		</>
	)
}